exports = module.exports = require("../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Layout__Content__1-u5l {\n  position: absolute;\n  top: 40px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  overflow: auto;\n}\n", ""]);

// exports
exports.locals = {
	"Content": "Layout__Content__1-u5l"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/Layout/Layout.css
// module id = 586
// module chunks = 0